function getLocationSnapshot(locationOverride) {
  if (locationOverride) {
    return locationOverride;
  }

  if (typeof window !== 'undefined' && window.location) {
    return window.location;
  }

  return {
    pathname: '/',
    search: '',
  };
}

export function buildAuthReturnTo(locationOverride) {
  const location = getLocationSnapshot(locationOverride);
  return `${location.pathname || '/'}${location.search || ''}`;
}

export function buildLoginRedirectOptions(locationOverride) {
  return {
    appState: {
      returnTo: buildAuthReturnTo(locationOverride),
    },
  };
}

export function buildLogoutReturnTo(locationOverride) {
  const location = getLocationSnapshot(locationOverride);

  if (location.origin) {
    return location.origin;
  }

  if (location.protocol && location.host) {
    return `${location.protocol}//${location.host}`;
  }

  return 'http://localhost:3000';
}

function sanitizeReturnTo(returnTo) {
  if (
    typeof returnTo !== 'string' ||
    !returnTo.startsWith('/') ||
    returnTo.startsWith('//')
  ) {
    return '/';
  }

  return returnTo;
}

export function handleAuthRedirectCallback(appState, options = {}) {
  const history =
    options.history || (typeof window !== 'undefined' ? window.history : null);
  const documentRef =
    options.document || (typeof document !== 'undefined' ? document : null);
  const targetUrl = sanitizeReturnTo(appState?.returnTo);

  history?.replaceState?.({}, documentRef?.title || '', targetUrl);

  return targetUrl;
}
